<div class="step-edit">
  @if (!isRequired) {
    <div
      class="field">
      <label>{{ 'MANAGEMENT.WORKFLOW.STEP-TYPE' | translate }}</label>
      <div class="select is-small is-fullwidth">
        <select [(ngModel)]="selectedType">
          @for (type of stepTypes; track type.value) {
            <option
              [ngValue]="type.value">
              {{ type.name }}
            </option>
          }
        </select>
      </div>
    </div>
  }

  <div class="field">
    <label>{{ 'MANAGEMENT.WORKFLOW.STEP-PROPERTIES' | translate }}</label>
    <div>
      <label class="checkbox">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <input
            type="checkbox"
            [value]="'initialStep'"
            [checked]="isInitialStep"
            (change)="initialStepChecked($event)"
            class="mr-3 checkbox-size" />
          <div class="checkbox-text">{{ 'MANAGEMENT.WORKFLOW.INITIAL-STEP' | translate }}</div>
        </div>
      </label>
    </div>
    <div>
      <label class="checkbox">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <input
            type="checkbox"
            [value]="'completeStep'"
            [checked]="isCompleteStep"
            (change)="completeStepChecked($event)"
            class="mr-3 checkbox-size" />
          <div class="checkbox-text">{{ 'MANAGEMENT.WORKFLOW.COMPLETE-STEP' | translate }}</div>
        </div>
      </label>
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="mt-4 mb-4">
    <div class="mr-1">
      @if (!isRequired) {
        <button
          class="button is-small is-secondary"
          (click)="deleteClick()">
          {{ 'DASHBOARDS.BUTTONS.DELETE' | translate }}
        </button>
      }
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end">
      <div class="mr-1">
        <button
          class="button is-small is-secondary"
          (click)="cancelClick()">
          {{ 'DASHBOARDS.BUTTONS.CANCEL' | translate }}
        </button>
      </div>
      <div>
        <button
          class="button is-small is-primary"
          (click)="saveClick()">
          {{ 'DASHBOARDS.BUTTONS.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


